module.exports = __webpack_public_path__ + "static/media/aehspromo2.c6b47265.jpg";